import React from 'react';
import { Box, Typography } from '@mui/material';
import SVGComponent from '../../../presentationalComponents/SVGComponent';

interface DistanceMarkerProps {
    text: string;
    color: string;
}

export default function DistanceMarker({ text, color }: DistanceMarkerProps) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
            <Box sx={{width: '4px', position: 'relative', mr: 2}}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: color,
                    }}
                >
                    <SVGComponent iconValue="camper"/>
                </Box>
            </Box>
            <Typography variant="body2" color={color} sx={{position: 'relative', top: '-2px'}}>
                {text}
            </Typography>
        </Box>
    );
}